import { useState } from 'preact/hooks';
import { LoginForm } from './LoginForm.jsx';
import { RegisterForm } from './RegisterForm.jsx';
import { ForgotForm } from './ForgotForm.jsx';
import css from './AuthScreen.module.css';

export function AuthScreen() {
  const [form, setForm] = useState('login');

  return (
    <div class={css.screen}>
      <div class={css.container}>
        <header class={css.header}>
          <div class={css.logo}>ООО «Кондор-Юг»</div>
          <div class={css.subtitle}>B2B Портал</div>
        </header>

        {form === 'login' && (
          <LoginForm onShowRegister={() => setForm('register')} onShowForgot={() => setForm('forgot')} />
        )}
        {form === 'register' && <RegisterForm onShowLogin={() => setForm('login')} />}
        {form === 'forgot' && <ForgotForm onBack={() => setForm('login')} />}

        <footer class={css.footer}>Свяжитесь с менеджером для получения доступа</footer>
      </div>
    </div>
  );
}
